import {lookupControllerBySerialNumber, provisionController, provisionTeam} from "../api"
import {AppError, UserConfirmationRequest } from "../models"


let intToASCIICompatibleInt = (int) => {
    let isASCIINumericValue = (int >= 48 && int <= 57)
    let isASCIIAlphaValue = ((int >= 65 && int <= 90) || (int >= 97 && int <= 122))
    if (isASCIIAlphaValue || isASCIINumericValue) {
        return int
    }

    let forceIntoASCII = (value) => {
        if (value <= 25) {
            // convert to upper alpha value
            return value + 65
        } else if (value > 57 && value < 65) {
            // convert into numeric
            return value - 10
        } else if (value > 25 && value < 48) {
            // convert to upper alpha value
            return value + 39
        } else if (value > 90 && value < 97) {
            // convert to lower alpha value
            return value + 10
        } else if (value > 122) {
            // convert to lower alpha value
            return value - 10
        }
    }

    return forceIntoASCII(int)
}


let generateRandomString = (length) => {
    let crypto = (window.crypto || window.msCrypto)
    let randInts = crypto.getRandomValues(new Uint8Array(length))
    let asciiInts = randInts.map(value => intToASCIICompatibleInt(Math.round(value/2)))
    let randChars = Array.from(asciiInts).map(value => String.fromCharCode(value))
    return randChars.join('')
}

export let downloadLinkForLogin = (username, password) => {
    let text = `UN:\x0d\x0a${username}\x0d\x0aPW:\x0d\x0a${password}\x0d\x0a`
    let blob = new Blob([text], {type:'text/plain'})
    let URL = window.URL || window.webkitURL
    return URL.createObjectURL(blob)
}

export let provisionSerialNumbers = async (token, serialNumbers, iccid, phoneNumber, forceReprovision=false, usernames=[], passwords=[]) => {
    let responses = []
    for (let i = 0; i < serialNumbers.length; i++) {
        let serialNumber = serialNumbers[i]
        let iccid_val = iccid[i]
        let phone = phoneNumber[i]
        let username = generateRandomString(18) // some random 18 alphanumeric value
        let password = generateRandomString(12) // some random 12 alphanumeric value
        let legacy = false

        if (usernames.length > i && passwords.length > i) {
            username = usernames[i]
            password = passwords[i]
        }
        try {
            let controller = await provisionController(token, serialNumber, iccid_val, phone, username, password, legacy, forceReprovision)
            responses.push({controller, username, password})
        } catch (error) {
            let appError, userConfirmationRequest
            if (error.message && error.message.includes("object_exists") && error.message.includes("force_reprovision")) {
                let serialLookupResponse = await searchSerialNumber(token, serialNumber, false, false)
                if (serialLookupResponse.controller) {
                    let controller = serialLookupResponse.controller
                    userConfirmationRequest = new UserConfirmationRequest("Reprovision Controller?",
                        (`Controller with serial number <strong>${serialNumber}</strong> already exists.` +
                            `<br/><br/>Reprovisioning will revoke the controller's current login and ` +
                            `create a new one. The controller will keep its data and stay on the same` +
                            ` team but will need the new login file. <br/><br/>The iccid and phone number field will be changed.<br><br>Are you sure you want ` +
                            `to reprovision it?`),
                        ((e) => (e)),
                        ((e) => (e)),
                        {controller, username, password, iccid_val, phone})
                    responses.push({userConfirmationRequest, controller, username, password, iccid_val, phone})
                } else {
                    appError = new AppError("Failed to Reprovision Controller",
                        `Unable to reprovision controller with serial number ${serialNumber}. ${serialLookupResponse.error.message}`)
                    responses.push({error:appError})
                }
            } else {
                appError = new AppError("Failed to Provision Controller",
                                        `Unable to provision controller with serial number ${serialNumber}. ${error.message}`)
                responses.push({error:appError})
            }
        }
    }

    return responses
}


export let searchSerialNumber = async (token, serial, fuzzySearch=false, hideAssigned=true, hideArchived=true, teamID=null) => {
    let response = {}
 
    try {
        if (fuzzySearch) {
            let controllers = await lookupControllerBySerialNumber(token, serial, fuzzySearch, hideAssigned, hideArchived, teamID)
            response = controllers.map((controller)=>({controller}))
        } else {
            let controller = await lookupControllerBySerialNumber(token, serial, fuzzySearch, hideAssigned, hideArchived, teamID)
            response = {controller}
        }
    } catch (error) {
        console.log(error)
        let appError = new AppError("Controller Not Found", `Unable to find controller with serial number: ${serial}.`)
        response = {error: appError}
    }

    return response
}


export let createTeam = async (token, teamName, adminEmail, controllerSerials, dealership=false) => {
    let response = null

    try {
        let team = await provisionTeam(token, teamName, adminEmail, controllerSerials, dealership)
        response = {team, adminEmail}
    } catch (error) {
        console.log(`Failed to create team ${teamName} with error:`)
        console.log(error.message)
        let appError
        if (error.message === "object_exists") {
            appError = new AppError("Failed to Provision Team",
                `Unable to provision team ${teamName} with admin ${adminEmail}. Team already exists with that user.`)
            response = {error:appError}
        } else {
            appError = new AppError("Failed to Provision Team",
                `Unable to provision team ${teamName} with admin ${adminEmail}. ${error.message}`)
            response = {error:appError}
        }
    }

    return response
}



// WEBPACK FOOTER //
// ./src/dataHelpers/provisioningHelpers.js